// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-up-button {
  --background: var(--color-white-accent);
  color: var(--color-black);
  --border-color: transparent;
}
@media (min-width: 991px) {
  .sign-up-button {
    min-height: 64px;
    font-size: 20px;
  }
}

ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-item {
  --border-width: 0.5px !important;
  --border-radius: 52px !important;
  --border-color: #272727;
  --border-bottom: none;
  border: none;
  padding-inline: 3%;
}
ion-item:not(:last-child) {
  margin-bottom: 12px;
}

@media (min-width: 991px) {
  ion-item.password {
    margin-bottom: 25px;
  }
}

.forgot-password {
  cursor: pointer;
  text-align: center;
  height: 40px;
  border-radius: 26px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.forgot-password h3 {
  color: var(--color-black) !important;
  font-size: 14px;
  text-transform: uppercase;
  text-decoration: underline;
  font-family: AppFontMedium, sans-serif;
}
.forgot-password:hover {
  background: #f2dbd9 !important;
}

.wrapper {
  padding: 15px 25px 5px;
}
@media (max-width: 992px) {
  .wrapper {
    padding: 50px 7px 20px;
  }
}

.stacked {
  position: relative;
  top: -10px;
  left: 0%;
  z-index: 2;
  left: 3%;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-label {
  font-family: AppFont;
  font-weight: 400;
  font-size: 11px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
}

.main-button {
  margin-top: 40px;
}
@media (min-width: 991px) {
  .main-button {
    margin-top: 0px;
    min-height: 64px;
    font-size: 20px;
    margin-bottom: 26px;
  }
}
.main-button:hover {
  --background: var(--primary-btn) !important;
}

ion-button {
  margin: 6px 0px;
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.button-wrapper ion-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media (min-width: 991px) {
  .button-wrapper ion-button {
    min-height: 40px;
    font-size: 16px;
  }
}
.button-wrapper ion-button p {
  font-family: AppFontMedium, sans-serif;
  color: white;
  width: 75%;
}
@media (min-width: 991px) {
  .button-wrapper ion-button p {
    width: -moz-fit-content;
    width: fit-content;
  }
}
.button-wrapper ion-button ion-icon {
  margin-right: 10px;
  zoom: 0.9;
}
@media (min-width: 991px) {
  .button-wrapper ion-button ion-icon {
    margin-right: 10px;
    zoom: 1;
  }
}
.button-wrapper ion-button.google {
  --background: #ebdfda;
}
.button-wrapper ion-button.google p {
  color: var(--color-black);
}
.button-wrapper ion-button.facebook {
  --background: #3b5997;
}
.button-wrapper ion-button.apple {
  --background: var(--color-black);
}
.button-wrapper ion-button.apple:hover {
  --background: var(--color-black) !important;
}

.wrapper-modal {
  border-radius: 26px;
  height: 100%;
  position: relative;
  overflow: auto;
  background: #f6f1ef;
}
@media (max-width: 992px) {
  .wrapper-modal {
    margin-top: 25px;
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    background: #f6f1ef;
    box-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;
  }
}
.wrapper-modal ion-item {
  --background: #f6f1ef;
}
.wrapper-modal .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  width: 25px;
  height: 25px;
  padding: 0px;
  z-index: 99;
}
.wrapper-modal .title-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: Title, sans-serif;
  font-size: 35px;
  letter-spacing: 0.08em;
  margin-bottom: 30px;
}
.wrapper-modal .subtitle-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  letter-spacing: 0.08em;
  text-wrap: balance;
  font-size: 10px;
  padding: 0px 20px;
  margin-bottom: 15px;
}
@media (min-width: 991px) {
  .wrapper-modal .subtitle-text {
    font-size: 12px;
    margin-bottom: 15px;
  }
}
.wrapper-modal .or {
  margin: 10px 0 15px;
}
.wrapper-modal .header-block {
  padding: 20px;
  border-bottom: 1px solid var(--color-black);
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    padding: 20px 40px 0px;
  }
}
.wrapper-modal .footer-block {
  padding: 20px;
}
@media (min-width: 991px) {
  .wrapper-modal .footer-block {
    padding: 3px 40px 10px;
  }
}

@media (min-width: 991px) {
  ion-button {
    min-height: 40px !important;
    font-size: 16px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/sign-in-modal/sign-in-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,uCAAA;EACA,yBAAA;EACA,2BAAA;AADD;ACHE;EDCF;IAME,gBAAA;IAEA,eAAA;EADA;AACF;;AAIA;EACC,6BAAA;AADD;;AAGA;EACC,gCAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;AAAD;AAEC;EACC,mBAAA;AAAF;;ACzBE;ED6BF;IAEE,mBAAA;EADA;AACF;;AAIA;EACC,eAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADD;AAEC;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,sCAAA;AAAF;AAEC;EACC,8BAAA;AAAF;;AAGA;EAIC,sBAAA;AAHD;AClDE;EDiDF;IAEE,sBAAA;EAGA;AACF;;AACA;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEA,QAAA;AACD;;AAEA;EACC,eAAA;EACA,mBAAA;AACD;;AAEA;EACC,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;AACD;;AAEA;EACC,gBAAA;AACD;ACzFE;EDuFF;IAGE,eAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;EAGA;AACF;AAFC;EACC,2CAAA;AAIF;;AADA;EACC,eAAA;AAID;;AAFA;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAKD;AAHC;EACC,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;AAIF;ACrHE;ED4GD;IAQE,gBAAA;IACA,eAAA;EAKD;AACF;AADE;EACC,sCAAA;EACA,YAAA;EACA,UAAA;AAGH;AChIE;ED0HA;IAME,uBAAA;IAAA,kBAAA;EAIF;AACF;AAFE;EACC,kBAAA;EACA,SAAA;AAIH;ACzIE;EDmIA;IAIE,kBAAA;IACA,OAAA;EAMF;AACF;AAJE;EACC,qBAAA;AAMH;AALG;EACC,yBAAA;AAOJ;AAJE;EACC,qBAAA;AAMH;AAJE;EACC,gCAAA;AAMH;AALG;EACC,2CAAA;AAOJ;;AAFA;EAWC,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AALD;AChKE;EDsJF;IAEE,gBAAA;IACA,mBAAA;IACA,8BAAA;IACA,+BAAA;IAEA,mBAAA;IACA,8CAAA;EAWA;AACF;AAJC;EACC,qBAAA;AAMF;AAJC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAMF;AAHC;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,8BAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;AAKF;AAHC;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAKF;ACnNE;EDoMD;IAaE,eAAA;IACA,mBAAA;EAMD;AACF;AAHC;EACC,mBAAA;AAKF;AAHC;EACC,aAAA;EACA,2CAAA;AAKF;AChOE;EDyND;IAIE,sBAAA;EAOD;AACF;AALC;EACC,aAAA;AAOF;ACxOE;EDgOD;IAGE,sBAAA;EASD;AACF;;AC7OE;EDyOD;IACC,2BAAA;IACA,0BAAA;EAQA;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n.sign-up-button {\n\t--background: var(--color-white-accent);\n\tcolor: var(--color-black);\n\t--border-color: transparent;\n\n\t@include desktop {\n\t\tmin-height: 64px;\n\n\t\tfont-size: 20px;\n\t}\n}\n\nion-item.input-error {\n\tmargin-bottom: 8px !important;\n}\nion-item {\n\t--border-width: 0.5px !important;\n\t--border-radius: 52px !important;\n\t--border-color: #272727;\n\t--border-bottom: none;\n\tborder: none;\n\tpadding-inline: 3%;\n\n\t&:not(:last-child) {\n\t\tmargin-bottom: 12px;\n\t}\n}\n\nion-item.password {\n\t@include desktop {\n\t\tmargin-bottom: 25px;\n\t}\n}\n\n.forgot-password {\n\tcursor: pointer;\n\ttext-align: center;\n\theight: 40px;\n\tborder-radius: 26px;\n\tcursor: pointer;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\th3 {\n\t\tcolor: var(--color-black) !important;\n\t\tfont-size: 14px;\n\t\ttext-transform: uppercase;\n\t\ttext-decoration: underline;\n\t\tfont-family: AppFontMedium, sans-serif;\n\t}\n\t&:hover {\n\t\tbackground: #f2dbd9 !important;\n\t}\n}\n.wrapper {\n\t@include mobile {\n\t\tpadding: 50px 7px 20px;\n\t}\n\tpadding: 15px 25px 5px;\n}\n\n.stacked {\n\tposition: relative;\n\ttop: -10px;\n\tleft: 0%;\n\tz-index: 2;\n\n\tleft: 3%;\n}\n\nion-note {\n\tfont-size: 12px;\n\tpadding-right: 10px;\n}\n\nion-label {\n\tfont-family: AppFont;\n\tfont-weight: 400;\n\tfont-size: 11px;\n\tline-height: 85%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-transform: capitalize;\n}\n\n.main-button {\n\tmargin-top: 40px;\n\t@include desktop {\n\t\tmargin-top: 0px;\n\t\tmin-height: 64px;\n\t\tfont-size: 20px;\n\t\tmargin-bottom: 26px;\n\t}\n\t&:hover {\n\t\t--background: var(--primary-btn) !important;\n\t}\n}\nion-button {\n\tmargin: 6px 0px;\n}\n.button-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\twidth: 100%;\n\n\tion-button {\n\t\twidth: 100%;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\n\t\t@include desktop {\n\t\t\tmin-height: 40px;\n\t\t\tfont-size: 16px;\n\t\t\t&:not(:last-child) {\n\t\t\t}\n\t\t}\n\n\t\tp {\n\t\t\tfont-family: AppFontMedium, sans-serif;\n\t\t\tcolor: white;\n\t\t\twidth: 75%;\n\n\t\t\t@include desktop {\n\t\t\t\twidth: fit-content;\n\t\t\t}\n\t\t}\n\t\tion-icon {\n\t\t\tmargin-right: 10px;\n\t\t\tzoom: 0.9;\n\t\t\t@include desktop {\n\t\t\t\tmargin-right: 10px;\n\t\t\t\tzoom: 1;\n\t\t\t}\n\t\t}\n\t\t&.google {\n\t\t\t--background: #ebdfda;\n\t\t\tp {\n\t\t\t\tcolor: var(--color-black);\n\t\t\t}\n\t\t}\n\t\t&.facebook {\n\t\t\t--background: #3b5997;\n\t\t}\n\t\t&.apple {\n\t\t\t--background: var(--color-black);\n\t\t\t&:hover {\n\t\t\t\t--background: var(--color-black) !important;\n\t\t\t}\n\t\t}\n\t}\n}\n.wrapper-modal {\n\t@include mobile {\n\t\tmargin-top: 25px;\n\t\tborder-bottom: none;\n\t\tborder-bottom-left-radius: 0px;\n\t\tborder-bottom-right-radius: 0px;\n\t\t// border: 2px solid var(--color-black);\n\t\tbackground: #f6f1ef;\n\t\tbox-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;\n\t}\n\n\tborder-radius: 26px;\n\theight: 100%;\n\tposition: relative;\n\toverflow: auto;\n\tbackground: #f6f1ef;\n\tion-item {\n\t\t--background: #f6f1ef;\n\t}\n\t.close-icon {\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t}\n\n\t.title-text {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: Title, sans-serif;\n\t\tfont-size: 35px;\n\t\tletter-spacing: 0.08em;\n\t\tmargin-bottom: 30px;\n\t}\n\t.subtitle-text {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFont, sans-serif;\n\t\tletter-spacing: 0.08em;\n\t\ttext-wrap: balance;\n\t\tfont-size: 10px;\n\t\tpadding: 0px 20px;\n\t\tmargin-bottom: 15px;\n\n\t\t@include desktop {\n\t\t\tfont-size: 12px;\n\t\t\tmargin-bottom: 15px;\n\t\t}\n\t}\n\n\t.or {\n\t\tmargin: 10px 0 15px;\n\t}\n\t.header-block {\n\t\tpadding: 20px;\n\t\tborder-bottom: 1px solid var(--color-black);\n\t\t@include desktop {\n\t\t\tpadding: 20px 40px 0px;\n\t\t}\n\t}\n\t.footer-block {\n\t\tpadding: 20px;\n\t\t@include desktop {\n\t\t\tpadding: 3px 40px 10px;\n\t\t}\n\t}\n}\n\n@include desktop {\n\tion-button {\n\t\tmin-height: 40px !important;\n\t\tfont-size: 16px !important;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
